import { OPERATION_MODE } from "@/common/constants";

const state = {
    loading: false,
    activeSidebar: true,
    activeDark: false,
    error: false,
    activeSound: true,
    operationMode: OPERATION_MODE,
    sidebarItems: [],
    cardLinksActive: [],
    cardLinksAvailable: [],
    cardLinksReviewed: [],
    cardLinksFavorites: [],
    tenantStackColors: null
};

export default state;
